module.exports = __webpack_public_path__ + "img/rotate.fb63108e.svg";